define('shared/initializer/form/adapters/mixins/upsell/EventHandlable',[
    '$'
], function (
    $
) {
    'use strict';

    function add($tr){
        var me = this;
        var offerId = $tr.attr('data-offer-id');
        var isAdded = $tr.hasClass('added');
        if (!isAdded) {
            $tr.addClass('added');
            if (offerId) {
                me.selectedOffers.push(offerId);
                me.renderTotal();
                setButtonStatus.call(me);
            }
        }
    }

    function remove($tr) {
        var me = this;
        var offerId = $tr.attr('data-offer-id');
        var isAdded = $tr.hasClass('added');
        if (isAdded) {
            $tr.removeClass('added');
            if (offerId) {
                var idx = me.selectedOffers.indexOf(offerId);
                me.selectedOffers.splice(idx, 1);
                me.renderTotal();
                setButtonStatus.call(me);
            }
        }
    }

    function setButtonStatus() {
        var me = this;
        if (!me.$submits) {
            throw new Error('SubmitButtonEnableable mixin required');
        }
        if (me.selectedOffers.length > 0) {
            me.$submits.removeAttr('disabled');
        }
        else {
            me.$submits.attr('disabled', 'disabled');
        }
    }

    function Ctor () {
        var me = this;
        me.selectedOffers = [];
    }

    var p = Ctor.prototype;

    p.doPageLoad = function() {
        var me = this;
        var $table = me.$form.find('> table.offers');

        me.renderTotal();

        $table.on('click', '.button-add > .button', function(evt) {
            var $currentTarget = $(evt.currentTarget);
            var $tr = $currentTarget.closest('tr.offer');
            add.call(me, $tr);
        });

        $table.on('click', '.button-remove > .button', function(evt) {
            var $currentTarget = $(evt.currentTarget);
            var $tr = $currentTarget.closest('tr.offer');
            remove.call(me, $tr);
        });

        $table.on('click', '.remove-all.link', function(){
            var $trs = $table.find('tr');
            $trs.each(function(i){
                remove.call(me, $trs.eq(i));
            });
        });
    };
    p.doAfterPageLoad = function() {
        var me = this;
        setButtonStatus.call(me);
    };

    return Ctor;
});
